// src/utils/AxiosUtils.js
import axios from 'axios';

// 创建axios实例
const apiClient = axios.create({
  baseURL: 'https://api2.pxin1.com', // 基础URL
  headers: {
    'Content-Type': 'application/json',
    // 默认情况下，如果有需要，可以在这里设置固定的Authorization头
    // 'Authorization': `Bearer ${YOUR_32_CHAR_TOKEN}`
  },
  timeout: 6000, // 请求超时时间
});

// 请求拦截器，用于添加Token
apiClient.interceptors.request.use((config) => {
  // 从Vuex或LocalStorage中获取Token，这里仅为示例
  const token = localStorage.getItem('token') || '';
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// 响应拦截器，处理错误
apiClient.interceptors.response.use(
  (response) => {
    let data = response.data;
    // 后端返回的 JSON 字符串可能带 BOM，需要去掉再 parse
    if (typeof data === 'string') {
      data = data.replace(/^\uFEFF/, '');
      try {
        data = JSON.parse(data);
      } catch (e) {
        // 解析失败就返回原字符串
      }
    }
    return data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export async function get(url, params = {}, config = {}) {
    return await apiClient.get(url, { params, ...config });
}

export async function post(url, data = {}, config = {}) {
    return await apiClient.post(url, data, config);
}

// 分页示例方法
export function paginate(url, params = {}) {
  return get(url, { ...params, _page: params.page || 1, _limit: params.limit || 10 });
}